import { useTranslation } from 'react-i18next';

function CreateDependencyGroupForm(props) {
  var onCancel = props.onCancel;
  var onConfirm = props.onConfirm;
  var onFilesChanged = props.onFilesChanged;
  var onNameChanged = props.onNameChanged;
  var onDependencyRemoved = props.onDependencyRemoved;
  var createGroupRequest = props.createGroupRequest;
  var editing = props.editing ?? false;
  var nameValue = props.nameValue;

  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-100 bg-opacity-80 dark:bg-gray-900 dark:bg-opacity-80 backdrop-blur-sm">
      {/* Card */}
      <div
        className="w-wrap bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 space-y-6"
      >
        {/* Title */}
        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 text-center">
          {editing ? t("createDependencyGroupForm.editHeader") : t("createDependencyGroupForm.header")}
        </h2>

        {/* Name input */}
        <div>
          <label
            htmlFor="name"
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            {t("createDependencyGroupForm.nameLbl")}
          </label>
          <input
            id="name"
            type="text"
            onChange={(e) => onNameChanged(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:focus:ring-indigo-400 bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500"
            value={nameValue}
          />
        </div>

        {/* Files input */}
        <div>
          <label
            htmlFor="files"
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            {t("createDependencyGroupForm.chooseFilesLbl")}
          </label>
          <input
            id="files"
            type="file"
            multiple
            onChange={(e) => onFilesChanged(e.target.files)}
            className="w-full text-sm text-gray-700 dark:text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-600 file:text-white hover:file:bg-indigo-700 dark:file:bg-indigo-500 dark:hover:file:bg-indigo-600"
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => onCancel()}
            className="px-4 py-2 rounded-md border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition"
          >
            {t("createDependencyGroupForm.cancelBtn")}
          </button>
          <button
            onClick={() => onConfirm()}
            className="px-4 py-2 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 dark:bg-indigo-500 dark:hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 disabled:opacity-50"
          >
            {t("createDependencyGroupForm.confirmBtn")}
          </button>
        </div>
        <div className="flex items-center flex-col">
          {(createGroupRequest.dependencies?.length ?? 0) > 0 ? (
            <div className="mt-4">
              <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                {t("createDependencyGroupForm.dependenciesHeader")}
              </h3>

              <div className="overflow-hidden rounded-md border border-gray-200 dark:border-gray-700">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
                  <thead className="bg-gray-50 dark:bg-gray-700">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-600 dark:text-gray-300">
                        {t("createDependencyGroupForm.nameLbl")}
                      </th>
                      <th className="w-20 px-4 py-2"></th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-800">
                    {createGroupRequest?.dependencies?.map((dep, index) => (
                      <tr
                        key={dep.name + index}
                        className="hover:bg-gray-50 dark:hover:bg-gray-700 transition"
                      >
                        <td className="px-4 py-2 text-sm text-gray-800 dark:text-gray-100">
                          {dep.name}
                        </td>

                        <td className="px-4 py-2 text-right">
                          <button
                            onClick={() => onDependencyRemoved(index)}
                            className="rounded-md bg-red-600 px-3 py-1 text-sm font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-400 transition"
                          >
                            {t("createDependencyGroupForm.deleteBtn")}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) :
            ("")}
        </div>
      </div>
    </div>
  );
} export default CreateDependencyGroupForm
